/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

function convertItemsToProperties (items) {
  // Initialize an empty object for properties
  let properties = {}

  // Iterate over each item in the array
  items.forEach(item => {
    // Add a new property to the properties object
    properties[`_${item.title}`] = item.tax.toString()
  })

  // Return the properties object
  return { properties }
}

async function addExciseTax (stateId) {
  const cartResponse = await fetch('/cart.js', {
    method: 'GET',
  })
  const cartData = await cartResponse.json()
  const url = 'https://vapeshack-backend-app-bsa22.ondigitalocean.app/tax/calc_and_create_excise_tax_prod'
  // const url = 'http://localhost:3000/tax/calc_and_create_excise_tax_prod'
  const exciseResp = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      stateId: stateId,
      lineItems: cartData.items,
    }),
  })
  const exciseObj = await exciseResp.json()
  const product = exciseObj?.product
  if (!product) {
    return false
  }
  const taxData = exciseObj?.taxData
  if (!product) {
    return true
  }
  const properties = convertItemsToProperties(taxData.items)
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: product.variants.edges[0].node.id.replace('gid://shopify/ProductVariant/', ''),
          quantity: 1,
          properties,
        }],
    }),
  })
}

async function updateExciseTax (stateId) {
  const cartResponse = await fetch('/cart.js', {
    method: 'GET',
    cache: 'no-store',
  })
  const cartData = await cartResponse.json()

  let quantity = 0
  const exciseTaxSubTotal = document.querySelector('#offcanvas-cart-excise-tax-value')
  const isFromAnotherCountry = window.sessionStorage.getItem('isFromAnotherCountry')

  try {
    const url = 'https://vapeshack-backend-app-bsa22.ondigitalocean.app/tax/calculate'
    // const url  = 'http://localhost:3000/tax/calculate'
    const excisePriceResp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        stateId: stateId,
        lineItems: cartData.items,
      }),
    })
    const excisePriceObj = await excisePriceResp.json()
    quantity = excisePriceObj?.summary
    exciseTaxSubTotal.textContent = Shopify.formatMoney(!isFromAnotherCountry ? quantity : 0)
    await removeExciseTaxProd(cartData)
  } catch (e) {
    return false
  }
}

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {

  const offcanvasCart = document.querySelector('#offcanvas-cart')
  const cartPage = document.querySelector('#cart')

  offcanvasCart?.classList.add('loading')
  cartPage?.classList.add('loading')

  const newResponse = await fetch(window.location.href)
  const text = await newResponse.text()
  const newDocument = new DOMParser().parseFromString(text, 'text/html')

  offcanvasCart?.querySelector('.offcanvas-body').replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
  offcanvasCart?.querySelector('.offcanvas-footer').replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))
  cartPage?.replaceWith(newDocument.querySelector('#cart'))

  document.querySelectorAll('.cart-count-badge').forEach((badge) => {
    badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
    badge.removeAttribute('hidden')
  })

  offcanvasCart?.classList.remove('loading')
  cartPage?.classList.remove('loading')

  window.dispatchEvent(new Event('updated.ecomify.cart'))
  const data = await response.json()
  const state = window.sessionStorage.getItem('userState')

  if (response.ok) {

    if (response.url.includes('add.js')) {
      offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')
      if (data.items?.length > 1) {
        const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]')

        elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
        elemAlertItemsAdded.removeAttribute('hidden')
      } else {
        offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]').removeAttribute('hidden')
      }

    } else {
      offcanvasCart?.querySelector('#offcanvas-cart-alert-updated').removeAttribute('hidden')
    }
    if (state) {
      await updateExciseTax(state)
    }
  } else {
    const alert = document.querySelector('#offcanvas-cart-alert-error')
    alert.querySelector('span').textContent = `${data.message} - ${data.description}`
    alert.removeAttribute('hidden')
  }

  if (offcanvasCart?.querySelector('#offcanvas-cart-empty')) {
    setTimeout(() => {
      bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide()
    }, 1000)
  }

  if (offcanvasCart?.querySelector('#cart-shipping-rates')) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector('shipping-rates-modal-country', 'shipping-rates-modal-province', {
      hideElement: 'shipping-rates-modal-province-wrapper',
    })
  }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: input.dataset.lineItemKey,
      quantity: input.value,
    }),
  })
  window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: btn.dataset.lineItemKey,
      quantity: 0,
    }),
  })
  window.refreshCartContents(response)
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

  const note = btn.closest('#cart-note').querySelector('[name="note"]').value

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note }),
  })

  btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

  setTimeout(() => {
    btn.innerHTML = btn.dataset.textBtnSave
  }, 4000)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = async (btn, event) => {
  const state = window.sessionStorage.getItem('userState')
  const isFromAnotherCountry = window.sessionStorage.getItem('isFromAnotherCountry')
  const cartResponse = await fetch('/cart.js', {
    method: 'GET',
  })
  const cartData = await cartResponse.json()
  await removeExciseTaxProd(cartData)
  event.preventDefault()
  event.stopPropagation()
  if (!state && !isFromAnotherCountry) {
    document.querySelector('#modal-excise-btn').click()
  } else {
    btn.style.height = btn.clientHeight + 'px'
    btn.disabled = true
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    try {
      if (!isFromAnotherCountry) {
        await addExciseTax(state)
      }
      window.location.href = '/checkout'
    } catch (e) {
      btn.innerHTML = `
        <div>
        <svg xmlns="http://www.w3.org/2000/svg" class="me-3" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            Checkout
</div>
    `
      btn.disabled = false

    }

  }

}

// Cart Goal - Animate width
const initCartGoal = () => {
  const progressBar = document.querySelector('#cart-goal .progress-bar')
  if (progressBar) {
    setTimeout(() => {
      progressBar.style.width = progressBar.dataset.width
    }, 250)
  }
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
  initCartGoal()
})

// Cart Goal - Free product
const initCartGoalFreeProduct = async () => {
  const cartGoal = document.querySelector('#cart-goal')
  if (!cartGoal) return

  const freeProductHandle = cartGoal.dataset.freeProductHandle
  if (!freeProductHandle.length) return

  const goalCompleted = cartGoal.dataset.goalCompleted === 'true'
  let isFreeProductInCart = false

  document.querySelectorAll('[data-cart-line-item]').forEach(elem => {
    if (elem.dataset.productHandle === freeProductHandle) {
      isFreeProductInCart = true
    }
  })

  const freeProductVariantId = Number(cartGoal.dataset.freeProductVariantId)

  if (goalCompleted) {
    if (!isFreeProductInCart) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: freeProductVariantId,
              quantity: 1,
            }],
        }),
      })
      window.refreshCartContents(response)
    }
  }

}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
  initCartGoalFreeProduct()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
  const card = document.querySelector('#cart-summary')

  if (!card) return

  if (window.matchMedia('max-width: 991px').matches) return

  const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
  const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

  card.style.position = 'sticky'
  card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
  initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

  const wrapper = document.querySelector('#cart-shipping-rates-collapse')

  wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
  wrapper.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
  wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
  wrapper.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
  wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
  wrapper.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

  const country = wrapper.querySelector('#shipping-rates-modal-country').value
  const province = wrapper.querySelector('#shipping-rates-modal-province').value
  const zip = wrapper.querySelector('#shipping-rates-modal-zip').value

  const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
    method: 'POST',
  })

  if (prepareResponse.ok) {
    const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)

    const data = await asyncRespose.json()

    let html = ''

    if (data.shipping_rates.length) {
      data.shipping_rates.forEach(elem => {
        html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
      })

      wrapper.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
      wrapper.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
    } else {
      wrapper.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `
      wrapper.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
    }
  } else {
    const data = await prepareResponse.json()

    let html = ''

    for (const [key, value] of Object.entries(data)) {
      html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
    }

    wrapper.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
    wrapper.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
  }

  btn.innerHTML = btn.dataset.text
}

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
  document.querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]').forEach(elem => {
    elem.addEventListener('click', () => {
      setTimeout(() => {
        const offcanvasBody = document.querySelector('#offcanvas-cart .offcanvas-body')
        offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
      }, 250)
    })
  })
}
fixScrollingOffcanvasCollapses()

window.addEventListener('updated.ecomify.cart', () => {
  fixScrollingOffcanvasCollapses()
})

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  })

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.dataset.variantId),
          selling_plan: Number(select.value),
        }],
    }),
  })

  window.refreshCartContents(response)
}

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
  let response

  if (input.checked) {
    response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          }],
      }),
    })
  } else {
    response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    })
  }
  window.refreshCartContents(response)
}

// Cart Min Order
const initCartMinOrder = () => {
  const wrapper = document.querySelector('#cart-min-order')
  if (!wrapper) return

  if (wrapper.dataset.goalReached === 'false') {
    wrapper.closest('form').querySelector('.btn-checkout').disabled = true
  }
}
initCartMinOrder()
window.addEventListener('updated.ecomify.cart', () => {
  initCartMinOrder()
})

// Shipping protection
const initCartShippingProtection = async () => {
  if (!document.querySelector('[data-shipping-protection-enabled="true"]')) return

  if (!window.sessionStorage.getItem('ecomify-shipping-protection-init')) {
    const variantId = Number(document.querySelector('[data-shipping-protection-variant-id]').dataset.shippingProtectionVariantId)

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          }],
      }),
    })

    window.refreshCartContents(response)
    window.sessionStorage.setItem('ecomify-shipping-protection-init', true)
  }
}
initCartShippingProtection()

window.onChangeCartShippingProtection = async (input) => {
  let response

  if (input.checked) {
    response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          }],
      }),
    })
  } else {
    response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    })
  }
  window.refreshCartContents(response)
}

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  })

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.value),
          selling_plan: select.dataset.sellingPlanId.length
            ? Number(select.dataset.sellingPlanId)
            : null,
        }],
    }),
  })

  window.refreshCartContents(response)
}

// Terms checkbox
const initTermsCheckbox = () => {
  const checkbox = document.querySelector('#cart-terms-checkbox')

  if (!checkbox) return

  const checkoutBtn = checkbox.closest('form').querySelector('.btn-checkout')
  checkoutBtn.disabled = true

  checkbox.addEventListener('change', () => {
    if (checkbox.checked) {
      checkoutBtn.disabled = false
    } else {
      checkoutBtn.disabled = true
    }
  })
}
initTermsCheckbox()

window.addEventListener('updated.ecomify.cart', () => {
  initTermsCheckbox()
})

// Excise tax update
window.onExciseTaxSelectChange = async () => {
  const userState = document.querySelector('#excise-tax select').value
  if (userState) {
    window.sessionStorage.setItem('userState', userState)
    const response = await fetch('/cart.js', {
      method: 'GET',
    })
    document.querySelector('#modal-excise-btn').click()
    await window.refreshCartContents(response)
    document.querySelectorAll('.btn-checkout').forEach(btn => btn.removeAttribute('disabled'))
  }
}


const statesData = {
  'states': [
    { 'name': 'Alabama', 'id': 1 },
    { 'name': 'Alaska', 'id': 2 },
    { 'name': 'American Samoa', 'id': 3 },
    { 'name': 'Arizona', 'id': 4 },
    { 'name': 'Arkansas', 'id': 5 },
    { 'name': 'Armed Forces Africa', 'id': 6 },
    { 'name': 'Armed Forces Americas', 'id': 7 },
    { 'name': 'Armed Forces Canada', 'id': 8 },
    { 'name': 'Armed Forces Europe', 'id': 9 },
    { 'name': 'Armed Forces Middle East', 'id': 10 },
    { 'name': 'Armed Forces Pacific', 'id': 11 },
    { 'name': 'California', 'id': 12 },
    { 'name': 'Colorado', 'id': 13 },
    { 'name': 'Connecticut', 'id': 14 },
    { 'name': 'Delaware', 'id': 15 },
    { 'name': 'District of Columbia', 'id': 16 },
    { 'name': 'Federated States Of Micronesia', 'id': 17 },
    { 'name': 'Florida', 'id': 18 },
    { 'name': 'Georgia', 'id': 19 },
    { 'name': 'Guam', 'id': 20 },
    { 'name': 'Hawaii', 'id': 21 },
    { 'name': 'Idaho', 'id': 22 },
    { 'name': 'Illinois', 'id': 23 },
    { 'name': 'Indiana', 'id': 24 },
    { 'name': 'Iowa', 'id': 25 },
    { 'name': 'Kansas', 'id': 26 },
    { 'name': 'Kentucky', 'id': 27 },
    { 'name': 'Louisiana', 'id': 28 },
    { 'name': 'Maine', 'id': 29 },
    { 'name': 'Marshall Islands', 'id': 30 },
    { 'name': 'Maryland', 'id': 31 },
    { 'name': 'Massachusetts', 'id': 32 },
    { 'name': 'Michigan', 'id': 33 },
    { 'name': 'Minnesota', 'id': 34 },
    { 'name': 'Mississippi', 'id': 35 },
    { 'name': 'Missouri', 'id': 36 },
    { 'name': 'Montana', 'id': 37 },
    { 'name': 'Nebraska', 'id': 38 },
    { 'name': 'Nevada', 'id': 39 },
    { 'name': 'New Hampshire', 'id': 40 },
    { 'name': 'New Jersey', 'id': 41 },
    { 'name': 'New Mexico', 'id': 42 },
    { 'name': 'New York', 'id': 43 },
    { 'name': 'North Carolina', 'id': 44 },
    { 'name': 'North Dakota', 'id': 45 },
    { 'name': 'Northern Mariana Islands', 'id': 46 },
    { 'name': 'Ohio', 'id': 47 },
    { 'name': 'Oklahoma', 'id': 48 },
    { 'name': 'Oregon', 'id': 49 },
    { 'name': 'Palau', 'id': 50 },
    { 'name': 'Pennsylvania', 'id': 51 },
    { 'name': 'Puerto Rico', 'id': 52 },
    { 'name': 'Rhode Island', 'id': 53 },
    { 'name': 'South Carolina', 'id': 54 },
    { 'name': 'South Dakota', 'id': 55 },
    { 'name': 'Tennessee', 'id': 56 },
    { 'name': 'Texas', 'id': 57 },
    { 'name': 'Utah', 'id': 58 },
    { 'name': 'Vermont', 'id': 59 },
    { 'name': 'Virgin Islands', 'id': 60 },
    { 'name': 'Virginia', 'id': 61 },
    { 'name': 'Washington', 'id': 62 },
    { 'name': 'West Virginia', 'id': 63 },
    { 'name': 'Wisconsin', 'id': 64 },
    { 'name': 'Wyoming', 'id': 65 },
  ],
}

const mapIdToStates = (stateId) => {
  const state = statesData.states.find(s => parseInt(s.id) === parseInt(stateId))
  return state ? state.name : false
}

const mapStatesToId = (stateName) => {
  const state = statesData.states.find(s => s.name.toLowerCase() === stateName.toLowerCase())
  return state ? state.id : false
}

const getGeoData = async () => {
  if (window.sessionStorage.getItem('geoData')) {
    return JSON.parse(window.sessionStorage.getItem('geoData'));
  } else{
    const url = 'https://api.ipdata.co?api-key=b0bdf847e87de06e55e80192883b33f2cbdbe4faa8df31a76d2e76b1'
    const response = await fetch(url)
    const data = await response.json()
    window.sessionStorage.setItem('geoData', JSON.stringify(data))
    return data;
  }
}

const getState = async () => {
  if (window.sessionStorage.getItem('userState')) {
    return window.sessionStorage.getItem('userState')
  }
  try {
    const data = await getGeoData()
    const stateId = mapStatesToId(data.region)
    if (data.country_code !== 'US') {
      return ''
    }
    if (stateId) {
      window.sessionStorage.setItem('userState', stateId.toString())
      const response = await fetch('/cart.js', {
        method: 'GET',
      })
      window.refreshCartContents(response)
    }
  } catch (e) {
    console.log(e)
    return ''
  }

}
const initExciseTax = async () => {
  const state = await getState()
  const isFromAnotherCountry = window.sessionStorage.getItem('isFromAnotherCountry')
  const select = document.querySelector('#excise-tax select')
  const checkbox = document.querySelector('#excise-tax-from-another-country')
  const modalBtn = document.querySelector('#modal-excise-btn')
  const modalTextP = document.querySelector('#modal-state-text')
  const modalTextState = document.querySelector('#modal-state-text b')
  const stateTitle = mapIdToStates(state)
  if (state && modalBtn) {
    select.value = state
    modalBtn.innerText = 'Change delivery state'
    modalTextState.innerText = stateTitle
    modalTextP.classList.remove('visually-hidden')
    await updateExciseTax(state)
  } else if (modalBtn) {
    modalBtn.innerText = 'Select delivery state'
    modalTextP.classList.add('visually-hidden')
  }
  if (isFromAnotherCountry) {
    checkbox.checked = true
    modalBtn.innerText = 'Select delivery state'
    modalTextP.classList.add('visually-hidden')

  }
}

async function removeExciseTaxProd (cartData) {
  try {
    const exciseProd = cartData.items.find(item => item.title === 'Excise Tax - State Mandated')
    if (exciseProd) {
      const updatedCart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: exciseProd.key,
          quantity: 0,
        }),
      })
      await window.refreshCartContents(updatedCart)
    }
  } catch (e) {
    console.log(e)
  }
}

initExciseTax()

const fireStateEvent = async () => {
  const data = await getGeoData();
  const event = new CustomEvent('customerLocationSet', {
    detail: {
      customerLocationState: data.region || '',
      customerLocationCountry: data.country_name || '',
    },
  })
  document.dispatchEvent(event)
}

fireStateEvent()

window.addEventListener('updated.ecomify.cart', () => {
  initExciseTax()
})

window.onExciseTaxCheckboxChange = async () => {
  const isFromAnotherCountry = document.querySelector('#excise-tax-from-another-country').checked
  if (isFromAnotherCountry) {
    window.sessionStorage.setItem('isFromAnotherCountry', isFromAnotherCountry)
  } else {
    window.sessionStorage.removeItem('isFromAnotherCountry')
  }
  const response = await fetch('/cart.js', {
    method: 'GET',
  })
  document.querySelector('#modal-excise-btn').click()
  window.refreshCartContents(response)

}

